import axios_instance from "../axios.config";

const GetReportTransport = async (newItem) => {
  const { academic_year_id, class_id, vehicle_id, stop_id } = newItem;
  const payload = {
    academic_year_id: academic_year_id,
    class_id: class_id,
    vehicle_id: vehicle_id,
    stop_id: stop_id,
  }
  const response = await axios_instance.post(
    "/student/get-report-transport",
    payload
  );
  console.log(response);
  if (response?.data?.status === "SUCCESS") {
    return response.data;
  } else {
    return [];
  }
}

export {
  GetReportTransport
};